export { default as SocialYoutube } from './inline-svgs/youtube.svg'
export { default as SocialFacebook } from './inline-svgs/facebook.svg'
export { default as SocialTwitter } from './inline-svgs/twitter.svg'
export { default as SocialInstagram } from './inline-svgs/instagram.svg'
export { default as SocialLinkedIn } from './inline-svgs/linkedin.svg'
export { default as SocialLink } from './inline-svgs/www.svg'
export { default as SocialDownload } from './inline-svgs/download.svg'
export { default as SearchIcon } from './inline-svgs/search-icon.svg'
export { default as CloseIcon } from './inline-svgs/close-icon.svg'
